import axios from "../../../../../axios";
import Cookies from "js-cookie";

//Get Hold Candidate
export const GetAllHoldCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetHoldCandidates", {
    token,
  });
};
